<template>
  <div class="applicant-page px-4 py-4 md:px-5">
    <div class="mx-auto space-y-5">
      <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div class="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
          <div>
            <p class="text-[15px] font-semibold text-slate-900">
              [{{ listPage.sugang.kname }} {{ listPage.sugang.sugangName }}] 신청자 리스트
            </p>
            <p class="mt-1 text-sm text-slate-500">수강 신청자 목록을 확인하고 검색, 삭제, 엑셀 다운로드할 수 있습니다.</p>
          </div>
        </div>
      </section>

      <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div class="grid gap-4 md:grid-cols-3">
          <div class="info-card">
            <span class="info-label">Company</span>
            <p class="info-value">{{ listPage.sugang.kname || "-" }}</p>
          </div>
          <div class="info-card">
            <span class="info-label">과정명</span>
            <p class="info-value">{{ listPage.sugang.sugangName || "-" }}</p>
          </div>
          <div class="info-card">
            <span class="info-label">진행상태</span>
            <p class="info-value">{{ listPage.sugang.status || "-" }}</p>
          </div>
        </div>

        <div class="mt-4 flex flex-wrap gap-2 text-sm text-slate-500">
          <span class="result-chip"
            >수강신청기간 {{ listPage.sugang.startDate || "-" }} ~ {{ listPage.sugang.endDate || "-" }}</span
          >
          <span class="result-chip">페이지 {{ listPage.searchParams.pageNum }}</span>
          <span class="result-chip">선택 {{ listPage.selectedCheckboxes.length }}건</span>
        </div>
      </section>

      <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div class="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
          <div class="grid flex-1 gap-4 md:grid-cols-2 xl:grid-cols-5">
            <label class="filter-field">
              <span class="filter-label">검색 기준</span>
              <select class="filter-control" v-model="listPage.searchParams.searchValue">
                <option value="0" selected>선택</option>
                <option value="name">이름</option>
                <option value="email">이메일</option>
                <option value="phone">핸드폰</option>
              </select>
            </label>

            <label class="filter-field">
              <span class="filter-label">신청구분</span>
              <select class="filter-control" v-model="listPage.searchParams.isNewSugang" @change="listPage.getRegisterList">
                <option value="">신청구분 선택</option>
                <option value="Y">신규</option>
                <option value="N">재수강</option>
              </select>
            </label>

            <label class="filter-field">
              <span class="filter-label">상태</span>
              <select class="filter-control" v-model="listPage.searchParams.waitStatus" @change="listPage.getRegisterList">
                <option value="">상태 선택</option>
                <option value="N">신청</option>
                <option value="Y">대기</option>
              </select>
            </label>

            <label class="filter-field">
              <span class="filter-label">배정유무</span>
              <select class="filter-control" v-model="listPage.searchParams.assign" @change="listPage.getRegisterList">
                <option value="">상태 선택</option>
                <option value="Y">배정완료</option>
                <option value="N">배정전</option>
                <option value="C">배정실패</option>
              </select>
            </label>

            <label class="filter-field">
              <span class="filter-label">지원여부</span>
              <select class="filter-control" v-model="listPage.searchParams.isSup" @change="listPage.getRegisterList">
                <option value="">상태 선택</option>
                <option value="Y">지원</option>
                <option value="N">일반</option>
              </select>
            </label>
          </div>

          <div class="grid gap-4 lg:grid-cols-[minmax(0,320px)_140px]">
            <label class="filter-field">
              <span class="filter-label">검색어</span>
              <input
                type="text"
                class="filter-control"
                v-model="listPage.searchParams.searchKeyword"
                @keyup.enter="listPage.getRegisterList"
              />
            </label>

            <button type="button" class="search-button" @click="listPage.getRegisterList">검색</button>
          </div>
        </div>
      </section>

      <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div class="mb-4 flex flex-col gap-3 border-b border-slate-200 pb-4 md:flex-row md:items-center md:justify-between">
          <div>
            <p class="text-base font-semibold text-slate-900">신청자 목록</p>
            <p class="mt-1 text-sm text-slate-500">총 {{ listPage.totalCnt }}건</p>
          </div>
          <div class="flex flex-col gap-3 sm:flex-row sm:items-center">
            <div class="flex flex-wrap gap-2 text-sm text-slate-500">
              <span class="result-chip">페이지당 {{ listPage.searchParams.pageSize }}건</span>
              <span class="result-chip">선택 {{ listPage.selectedCheckboxes.length }}건</span>
            </div>
            <div class="flex flex-col gap-3 sm:flex-row">
              <button type="button" class="excel-button" @click="listPage.excelDownload">Excel 다운로드</button>
              <button type="button" class="danger-button" @click="listPage.delContents">삭제</button>
            </div>
          </div>
        </div>

        <div class="table-scroll-wrap rounded-xl border border-slate-200">
          <BagicTable
            :header="listPage.tableHeader"
            :list="listPage.sugangMemberList"
            :pageSize="listPage.searchParams.pageSize"
            :totalRows="listPage.totalCnt"
            :enableCheckBox="true"
            :checkParamName="listPage.checkParamName"
            @paging-click="listPage.movePage"
            :detailRowName="listPage.detailRowName"
            :detailParamName="listPage.detailParamName"
            @check-click="listPage.checkBoxClick"
          >
          </BagicTable>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRoute } from "vue-router";
import axios from "@/plugins/axios.js";
import BagicTable from "@/components/BagicTable.vue";
export default {
  components: {
    BagicTable,
  },
  setup() {
    const route = useRoute();

    const listPage = reactive({
      searchParams: {
        idxLeSugang: "",
        isNewSugang: "",
        pageNum: 1,
        pageSize: 50,
        searchKeyword: "",
        searchValue: "0",
        waitStatus: "",
        assign: "",
        isSup: "",
      },
      tableHeader: {
        rowNum: "No",
        createDate: "신청일",
        isNewSugang: "신청구분",
        sugangSupType: "대상자구분",
        waitStatus: "상태",
        assign: "배정유무",
        memberName: "이름",
        memberEmail: "이메일",
        memberMobile: "핸드폰번호",
        sugangLecType: "스케줄",
        sugangLang: "언어",
        sugangType: "수업유형",
        sugangClassName: "클래스",
        sugangName: "과정",
        sugangLevel: "레벨",
        learnTime: "수업기간/횟수",
        lecDayString: "신청요일",
        sugangHopeTime1: "희망시간1",
        sugangHopeTime2: "희망시간2",
        // classTeacher: "강사",
        status: "결제여부",
        updateDate: "수정/취소일",
        supDocument: "지원서류",
      },
      sugang: {
        endDate: "",
        kname: "",
        startDate: "",
        status: "",
        sugangName: "",
      },
      sugangMemberList: [],

      selectedCheckboxes: [],

      checkParamName: "rowNum",

      totalCnt: 0,

      // 리스트 조회 및 검색
      getRegisterList() {
        listPage.searchParams.idxLeSugang = route.query.idxLeSugang;
        axios
          .get("/admin/registerList", {
            params: listPage.searchParams,
          })
          .then(function (res) {
            if (res.data.success) {
              listPage.totalCnt = res.data.data.totalCnt;
              listPage.sugang = res.data.data.sugang;
              listPage.sugangMemberList = res.data.data.sugangMemberList;
              if (Array.isArray(listPage.sugangMemberList)) {
                listPage.sugangMemberList.forEach(function (item) {
                  item.name = `<u><a href="/enrolmentStep1?idxLeSiteMain=${item.idxLeSiteMain}">${item.name}</a></u>`;
                  item.email = `<u><a href="/enrolmentStep1?idxLeSiteMain=${item.idxLeSiteMain}">${item.email}</a></u>`;
                  if (item.supDocument) {
                    item.supDocument = `<a href="${item.supDocument}" target="_blank">지원서류 보기</a>`;
                  }
                });
              }
            } else {
              // alert(res.data.message);
            }
            // listPage.is_loader = false;
          });
      },

      checkBoxClick(selectedCheckboxes) {
        // 선택된 체크박스 정보를 상태에 저장
        listPage.selectedCheckboxes = selectedCheckboxes;
      },

      /**
       * [2024-12-24] 선택된 항목 중 sugangLecType이 "1:1"이 아닌 경우가 있는지 확인
       * @returns {boolean} 1:1이 아닌 항목이 있으면 true, 모두 1:1이면 false
       */
      hasNonOneToOneLecType() {
        return listPage.selectedCheckboxes.some((checkboxId) => {
          const selectedItem = listPage.sugangMemberList.find((item) => item[listPage.checkParamName] === checkboxId);
          return selectedItem && selectedItem.sugangLecType !== "1:1";
        });
      },

      async delContents() {
        const idxLeSugang = listPage.searchParams.idxLeSugang;
        const selectedIdxLeSugangPayInfoList = listPage.selectedCheckboxes.map((checkboxId) => {
          const selectedItem = listPage.sugangMemberList.find((item) => item[listPage.checkParamName] === checkboxId);
          return selectedItem ? selectedItem.idxLeSugangPayInfo : null;
        });

        if (selectedIdxLeSugangPayInfoList.length === 0) {
          alert("선택된 수강신청자 정보가 없습니다.");
          return;
        }

        if (listPage.hasNonOneToOneLecType()) {
          alert("1:1 수업만 삭제할 수 있습니다.");
          return;
        }

        if (!confirm("선택한 항목을 삭제하시겠습니까?")) {
          return;
        }

        try {
          const res = await axios.delete("/admin/registerDelete", {
            data: {
              idxLeSugang: idxLeSugang,
              idxLeSugangPayInfoList: selectedIdxLeSugangPayInfoList,
            },
          });

          if (res.data.success) {
            alert("선택한 항목 삭제 완료");
            listPage.getRegisterList();
          } else {
            alert("삭제 실패");
          }
        } catch (error) {
          console.error("삭제 요청 중 오류 발생:", error);
          alert("삭제 요청 중 오류가 발생했습니다.");
        }
      },

      excelDownload() {
        if (listPage.selectedCheckboxes.length === 0) {
          // alert("선택된 항목이 없습니다.");
          const params = {
            idxLeSugang: listPage.searchParams.idxLeSugang,
            idxLeSugangOnePayInfoList: selectedData,
          };

          axios({
            url: "/admin/registerListExcel",
            method: "GET",
            params: params,
            responseType: "blob",
          })
            .then((res) => {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "lifeClassList.xlsx");
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            })
            .catch((err) => {
              console.error(err);
              return false;
            });
          return;
        }

        const selectedData = listPage.selectedCheckboxes
          .map((checkboxId) => {
            const selectedItem = listPage.sugangMemberList.find((item) => item[listPage.checkParamName] === checkboxId);
            return selectedItem ? selectedItem.idxLeSugangPayInfo : null;
          })
          .filter((idx) => idx !== null);

        const params = {
          idxLeSugang: listPage.searchParams.idxLeSugang,
          idxLeSugangOnePayInfoList: selectedData.join(),
        };

        axios({
          url: "/admin/registerListExcel",
          method: "GET",
          params: params,
          responseType: "blob",
        })
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "lifeClassList.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch((err) => {
            console.error(err);
            return false;
          });
      },

      movePage(value) {
        listPage.searchParams.pageNum = value;
        listPage.getRegisterList();
      },
    });

    onMounted(() => {
      listPage.getRegisterList();
    });

    return {
      listPage,
    };
  },
};
</script>
<style scoped>
.applicant-page {
  min-height: 100%;
  background: radial-gradient(circle at top left, rgba(226, 232, 240, 0.65), transparent 32rem),
    linear-gradient(180deg, #f8fafc 0%, #ffffff 42%);
}

.info-card {
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #f8fafc;
  padding: 1rem;
}

.info-label,
.filter-label {
  font-size: 0.75rem;
  font-weight: 700;
  color: #64748b;
}

.info-value {
  margin-top: 0.5rem;
  word-break: break-all;
  font-size: 1.05rem;
  font-weight: 700;
  color: #0f172a;
}

.filter-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.filter-control {
  height: 2.875rem;
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  background-color: #fff;
  padding: 0.7rem 0.9rem;
  font-size: 0.95rem;
  color: #0f172a;
  outline: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.filter-control:focus {
  border-color: #94a3b8;
  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.15);
}

.danger-button,
.excel-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: #fff;
  transition: background-color 0.2s ease;
}

.search-button {
  margin-top: auto;
  display: inline-flex;
  height: 2.875rem;
  align-items: center;
  justify-content: center;
  border: 1px solid #2563eb;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.7rem 1rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: #2563eb;
  transition: background-color 0.2s ease;
}

.search-button {
  background: #fff;
}

.search-button:hover {
  background: #f8fafc;
}

.danger-button,
.excel-button {
  min-height: 2.875rem;
  border: 1px solid currentColor;
  background: #fff;
  padding: 0.7rem 1.1rem;
}

.danger-button {
  color: #dc2626;
}

.danger-button:hover {
  background: #f8fafc;
}

.excel-button {
  color: #059669;
}

.excel-button:hover {
  background: #f8fafc;
}

.result-chip {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 0.4rem 0.8rem;
}

.table-scroll-wrap {
  max-height: calc(100vh - 260px);
  overflow: auto;
}

:deep(table) {
  margin-bottom: 0;
  table-layout: auto;
}

:deep(thead tr) {
  background: #f8fafc;
}

:deep(th) {
  border-color: #e2e8f0;
  padding: 0.85rem 0.65rem;
  font-size: 0.82rem;
  font-weight: 700;
  color: #334155;
  white-space: nowrap;
}

:deep(td) {
  border-color: #e2e8f0;
  padding: 0.85rem 0.65rem;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #334155;
  background-color: #fff;
  white-space: nowrap;
}

:deep(tbody tr:nth-child(even) td) {
  background-color: #fbfdff;
}

:deep(tbody tr:hover td) {
  background-color: #f8fbff;
}

:deep(td p) {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 2rem;
}

:deep(td a),
:deep(td button) {
  white-space: nowrap;
}

:deep(td a) {
  color: #0369a1;
  font-weight: 700;
  text-decoration: none;
}

:deep(.bg-white.border-t.border-gray-200) {
  border-top: 1px solid #e2e8f0;
  background: #fff;
}

:deep(nav[aria-label="Pagination"]) {
  gap: 0.25rem;
}

:deep(nav[aria-label="Pagination"] > span),
:deep(nav[aria-label="Pagination"] .relative.inline-flex) {
  border-radius: 14px;
}

:deep(nav[aria-label="Pagination"] .z-10) {
  background: #1d4ed8;
  color: #fff;
}

@media (max-width: 1024px) {
  :deep(table) {
    min-width: 1600px;
  }
}
</style>
